var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColoredWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(-236 -444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20,5v5a4.724,4.724,0,0,1-5,5H5a4.724,4.724,0,0,1-5-5V5A4.654,4.654,0,0,1,4.19.06,5.322,5.322,0,0,1,5,0H15a4.573,4.573,0,0,1,.75.05A4.664,4.664,0,0,1,20,5Z",
    transform: "translate(238 451)",
    fill: "none",
    stroke: "#2d94c6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.56,5.05A4.573,4.573,0,0,0,10.81,5H.81A5.322,5.322,0,0,0,0,5.06a3.043,3.043,0,0,1,.58-.78L3.83,1.02a3.525,3.525,0,0,1,4.96,0l1.75,1.77A3.374,3.374,0,0,1,11.56,5.05Z",
    transform: "translate(242.191 446)",
    fill: "none",
    stroke: "#2d94c6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5,0H2A2,2,0,0,0,2,4H5",
    transform: "translate(253 456.5)",
    fill: "none",
    stroke: "#2d94c6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(236 444)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredWallet);
export default __webpack_public_path__ + "static/media/coloredWallet.c9089569e4ca79bd4e1764500171d10c.svg";
export { ForwardRef as ReactComponent };